import { v } from "convex/values";
import {
  internalControl,
  defineTableWithInternalControl,
} from "../../../lib/shared/validators";

export const workOrderPersonnelStatus = v.union(
  v.literal("assigned"),
  v.literal("in_progress"),
  v.literal("completed"),
);

export const validatorWorkOrderPersonnel = v.object({
  workOrderId: v.id("work_orders"),
  personnelId: v.id("personnel"),
  roleSnapshot: v.optional(v.string()),
  hoursWorked: v.optional(v.number()),
  unitsCompleted: v.optional(v.number()),
  rateApplied: v.optional(v.number()),
  cost: v.optional(v.number()),
  status: v.optional(workOrderPersonnelStatus),
  notes: v.optional(v.string()),
  // Indica que este miembro es el responsable principal de la orden.
  isLead: v.optional(v.boolean()),
  internalControl,
});

export const work_order_personnel = defineTableWithInternalControl(
  validatorWorkOrderPersonnel,
)
  .index("by_work_order", ["workOrderId"])
  .index("by_personnel", ["personnelId"])
  .index("by_work_order_and_personnel", ["workOrderId", "personnelId"])
  .index("by_company_and_work_order", [
    "internalControl.companyId",
    "workOrderId",
  ])
  .index("by_branch_and_work_order", [
    "internalControl.branchId",
    "workOrderId",
  ]);
